import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    TgButtons2Module,
    TgGridModule,
    TgIconBasicPlusModule,
    TgIconBasicMinusModule,
    TgRackModule,
    TgSvgModule
} from '@trademe/tangram';
import { SummaryPageDescriptionFieldComponent } from './summary-page-description-field.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgButtons2Module,
        TgGridModule,
        TgIconBasicPlusModule,
        TgIconBasicMinusModule,
        TgRackModule,
        TgSvgModule
    ],
    declarations: [SummaryPageDescriptionFieldComponent],
    exports: [SummaryPageDescriptionFieldComponent]
})
export class SummaryPageDescriptionFieldModule {}
